import AgoraRTM from "agora-rtm-sdk";


const { RTM } = AgoraRTM;

class RTMService {
  private client: any = null;
  private currentUserId: string | null = null;
  private currentChannelId: string | null = null;
  private isSubscribed = false;

  async initialize({
    appId,
    userId,
    token,
  }: {
    appId: string;
    userId: string;
    token: string;
  }) {
    if (this.client && this.currentUserId === userId) {
      return;
    }

    if (this.client) {
      await this.cleanup();
    }

    this.client = new RTM(appId, userId, {
      useStringUserId: true,
    });
    this.currentUserId = userId;

    await this.client.login({ token });
  }

  async joinChannel(channelId: string) {
    if (!this.client) {
      throw new Error("RTM client is not initialized");
    }

    if (this.isSubscribed && this.currentChannelId === channelId) {
      return;
    }

    if (this.isSubscribed) {
      await this.leaveChannel();
    }

    await this.client.subscribe(channelId, {
      withPresence: true,
      withMetadata: false,
      withLock: false,
    });

    this.currentChannelId = channelId;
    this.isSubscribed = true;
  }

  async leaveChannel() {
    if (this.client && this.currentChannelId && this.isSubscribed) {
      await this.client.unsubscribe(this.currentChannelId);
    }

    this.currentChannelId = null;
    this.isSubscribed = false;
  }

  async cleanup() {
    try {
      await this.leaveChannel();
    } finally {
      if (this.client) {
        await this.client.logout();
      }

      this.client = null;
      this.currentUserId = null;
      this.currentChannelId = null;
      this.isSubscribed = false;
    }
  }
}

export const rtmService = new RTMService();
